<h2 mat-dialog-title>{{ isEditMode ? 'Editar Estatus' : 'Crear Nuevo Estatus' }}</h2>

<mat-dialog-content>
    <form [formGroup]="statusForm" class="status-form">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Clave del Estatus</mat-label>
            <input matInput formControlName="status" placeholder="ej. Facturada, Pagada">
            <mat-hint *ngIf="isEditMode">La clave no se puede modificar</mat-hint>
            <mat-error *ngIf="statusForm.get('status')?.hasError('required')">
                La clave es requerida
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre para Surtimiento</mat-label>
            <input matInput formControlName="nombreSurtimiento" placeholder="ej. Facturada">
            <mat-hint>Nombre mostrado en órdenes de surtimiento</mat-hint>
            <mat-error *ngIf="statusForm.get('nombreSurtimiento')?.hasError('required')">
                El nombre para surtimiento es requerido
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre para Cobranza (opcional)</mat-label>
            <input matInput formControlName="nombreCobranza" placeholder="ej. Facturada">
            <mat-hint>Nombre mostrado en monitores de facturación (si es diferente)</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Descripción</mat-label>
            <textarea matInput formControlName="description" rows="3" placeholder="Descripción del estatus"></textarea>
            <mat-error *ngIf="statusForm.get('description')?.hasError('required')">
                La descripción es requerida
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Orden de Visualización</mat-label>
            <input matInput type="number" formControlName="order" min="0">
            <mat-error *ngIf="statusForm.get('order')?.hasError('required')">
                El orden es requerido
            </mat-error>
            <mat-error *ngIf="statusForm.get('order')?.hasError('min')">
                El orden debe ser mayor o igual a 0
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Variaciones (presiona Enter para agregar)</mat-label>
            <mat-chip-grid #chipGrid>
                @for (variation of variations; track variation) {
                <mat-chip-row (removed)="removeVariation(variation)">
                    {{ variation }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
                }
            </mat-chip-grid>
            <input placeholder="Nueva variación..." [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addVariation($event)" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Color (opcional)</mat-label>
            <input matInput type="color" formControlName="color">
            <mat-hint>Color del chip en monitores y órdenes</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Grupo del Dashboard (opcional)</mat-label>
            <input matInput formControlName="dashboardGroup" list="dashboardGroupsList"
                placeholder="ej. Procesada, Tesorería...">
            <datalist id="dashboardGroupsList">
                @for (group of existingDashboardGroups; track group) {
                <option [value]="group"></option>
                }
            </datalist>
            <mat-hint>Estatus con el mismo grupo se agregan juntos en el dashboard. Vacío = grupo "Otros".</mat-hint>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!statusForm.valid">
        {{ isEditMode ? 'Guardar Cambios' : 'Crear Estatus' }}
    </button>
</mat-dialog-actions>